import Observer from './Observer'
import Emitter from './Emitter'

export default {

  install (Vue, connection, opts = {}) {
    if (!connection) { throw new Error('[vue-native-socket] cannot locate connection') }

    const observer = new Observer(Vue, connection, opts)

    Vue.prototype.$socket = observer.WebSocket

    Vue.mixin({
      created () {
        const sockets = this.$options.sockets

        this.$options.sockets = {}

        if (sockets) {
          Object.keys(sockets).forEach((key) => {
            this.$options.sockets[key] = sockets[key]
            Emitter.addListener(key, sockets[key], this)
          })
        }
      },
      beforeDestroy () {
        const sockets = this.$options.sockets
        clearTimeout(observer.reconnectTimeoutId)

        if (sockets) {
          Object.keys(sockets).forEach((key) => {
            Emitter.removeListener(key, sockets[key], this)
            delete this.$options.sockets[key]
          })
        }
      }
    })
  }
}
